<template>
	<div class="bg-white" v-loading="loadings.items">
		<hr />
		<h3 class="cursor-pointer" @click="showItems = !showItems">
			商品选择
			<span>{{ tips }}</span>
			<span>
				<i :class="{ 'el-icon-arrow-down': !showItems, 'el-icon-arrow-up': showItems }"></i>
			</span>
		</h3>
		<div class="row" v-show="showItems">
			<div class="col-md-8">
				<el-form
					class="row"
					ref="insertForm"
					:model="formItem"
					status-icon
					label-position="left"
					label-width="100px"
					size="mini"
					v-loading="loadings.insert"
					@submit.native.prevent
					:rules="itemRules"
					:inline="true"
				>
					<div class="col-md-4">
						<el-form-item label="仓库" prop="brand">
							<warehouse-input
									size="small"
									v-model="warehouse"
									ref="formItemBrand"
							></warehouse-input>
						</el-form-item>
					</div>
					<div class="col-md-4">
						<el-form-item label="分类" prop="classify">
							<classify-input
								size="small"
								v-model="classify"
								ref="formItemClassify"
							></classify-input>
						</el-form-item>
					</div>
					<div class="col-md-4">
						<el-form-item label="品牌" prop="brand">
							<brand-input
								size="small"
								v-model="brand"
								ref="formItemBrand"
							></brand-input>
						</el-form-item>
					</div>
					<div class="col-md-4">
						<el-form-item label="货号/商品" prop="product_color">
							<!-- <product-input
								size="small"
								v-model="product_color"
								ref="formItemProduct"
								:params="{kvFilter:productFilters}"
							></product-input>-->
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="商品名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</el-form-item>
					</div>

          <div class="col-md-4">
            <el-form-item label="SKU编码">
              <el-input
                  @input="bianmaClick"
                  size="mini"
                  v-model="bianMa"
                  placeholder="SKU编码"
                  clearable
              ></el-input>
            </el-form-item>
          </div>

					<div class="col-md-4">
						<el-checkbox v-model="isCheckHasValue">只看有货</el-checkbox>
					</div>
					<div class="col-md-4">
						<el-button type="primary" size="mini" v-if="hasSelectAll" @click="handleChooseAllFilter()"
									>全选</el-button
								>
					</div>
					<div class="col-12">
						<curd-table
							ref="listTable"
							data-model="Product_color"
							:fields="tableFields"
							:per-page="10"
							:kv-filter="itemFilters"
							:search-filter="filterTableSearch"
							:has-filter="false"
							@gettotal="onGetData"
						>
							<template slot="listOp" slot-scope="scope">
								<el-button type="text" size="mini" @click="handleChoose(scope.row)"
									>选中</el-button
								>
								<el-button type="text" size="mini" v-if="hasSelectAll" @click="handleChooseAll(scope.row)"
									>全选</el-button
								>
							</template>
						</curd-table>
					</div>
				</el-form>
			</div>
			<div class="col-md-4 bg-white h-auto" v-if="product_color._id && warehouse._id" >
				<warehouse-items-matrix
					ref="itemsMatrix"
					:product_color="product_color"
					:warehouse-id="warehouseIdNew"
					v-model="stocks"
					v-bind="$attrs"
				></warehouse-items-matrix>
				<div class="clearfix"></div>
				<div class="btn-holder mt-3 ml-3 mr-3 mb-3 text-right" v-loading="loadings.insert">
					<el-button size="mini" @click="handleResetClear()">清 空</el-button>
					<el-button size="mini" type="success" @click="handleInsert()">添 加</el-button>
				</div>
			</div>
			<div class="col-md-4 bg-white" v-if="!product_color._id">
				<div class="h-auto el-table__empty-block">
					<span class="el-table__empty-text">请先选择商品</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ItemsSearch from "@/mixinsApp/ItemsSearch.js";
import WarehouseItemsMatrix from "@/widgets/WarehouseItemsMatrix.vue";

export default {
	components:{
		WarehouseItemsMatrix
	},
	inheritAttrs: false,
	mixins: [ItemsSearch],

	data() {
		return {
      priceRate : [],
      bianMa:'',
			loadings:{
				items:false
			},
			showItems: true,
			dataCounts:0,
			tableFields: [
				{
					name: "brand",
				},
				{
					name: "brand_show_id",
					width: "160px",
					needThumb: "thumb_img",

					params: {
						multiHidden: false,
					},
					render: (info) => {
						return `${info.brand_show_id}-${info.color_code}`;
					},
				},

				{
					name: "name",
					params: {
						multiHidden: false,
					},
				},
				{
					name: "color_name",
					render: (info) => {
						if (!info.color_name) {
							return info.color.name;
						} else {
							return info.color_name;
						}
					},
				},
				{
					name: "amount",
					render: (info) => {
						if (info.is_pre_sale) {
							return info.amount_pre + "(预售)";
						} else {
							return info.amount;
						}
					},
				},
			],
			itemRules: {
				warehouse:[
					{
						require:true
					}
				],
				product_color: [
					{
						type: "object",
						fields: {
							_id: {
								type: "string",
								required: true,
								message: "必须选择有效数据",
							},
						},
					},
				],
				price_per: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
					},
					{
						type: "number",
						min: 0.01,
						message: "请输入",
						trigger: "change",
					},
				],
			},
			isCheckHasValue: false,
			warehouseIdNew: {
				type: String,
				default: "",
			},

		};
	},
	computed: {
		referencePrice() {
			if (this.isUsePrice) {
				if (this.agentLevel.index == 0) {
					return 0 + this.product_color.price_1;
				} else if (this.agentLevel.index == 1) {
					// return 0 + this.product_color.price_1 * this.priceRate[1];
					return 0 + this.product_color.price_1;
				} else if (this.agentLevel.index == 2) {
					return 0 + this.product_color.price_3;
				} else if (this.agentLevel.index == 3) {
					return 0 + this.product_color.price_4;
				} else if (this.agentLevel.index == 4) {
					return 0 + this.product_color.price_5;
				} else if (this.agentLevel.index == 5) {
          // return 0 + this.product_color.price_1 * this.priceRate[5];
          return 0 + this.product_color.price_1;
        } else {
					return 0 + this.product_color.price_1;
				}
			} else {
				return 0 + this.product_color.cost_per;
			}
		},
    rate(){
			console.log("agentLevel",this.agentLevel)
      if (this.isUsePrice) {
        if (this.agentLevel.index == 0) {
          return '无折扣';
        } else if (this.agentLevel.index == 1) {
          return this.priceRate[1] == 1 ? "无折扣":this.priceRate[1]*10+'折';
        } else if (this.agentLevel.index == 2) {
          return '无折扣';
        } else if (this.agentLevel.index == 3) {
          return '无折扣';
        } else if (this.agentLevel.index == 4) {
          return '无折扣';
        } else if (this.agentLevel.index == 5) {
          return this.priceRate[5] == 1 ? "无折扣":this.priceRate[5]*10+'折';
        } else {
          return '无折扣';
        }
      } else {
        return '无折扣';
      }
    },
		itemFilters() {
			let filter = {};
			if (this.brand._id != "") {
				filter.brand = { k: "brand", t: "_id", v: this.brand._id };
			}
			if (this.classify.length != 0) {
				filter.classify = {
					k: "classify",
					t: "classify",
					v: this.classify[this.classify.length - 1]._id,
				};
			}
			if (this.filter) {
				for (let k in this.filter) {
					filter[k] = this.filter[k];
				}
			}
			if (this.isPreSale) {
				filter.is_pre_sale = { k: "is_pre_sale", t: "int", lge: "==", v: 1 };
			}
			if (this.isCheckHasValue) {
				filter.amount = { k: "amount", t: "int", lge: ">", v: 0 };
			}
			return filter;
		},
	},

	props: {
		isNeedCost: {
			type: Boolean,
			default: false,
		},
		isUsePrice: {
			type: Boolean,
			default: false,
		},
		isPreSale: {
			type: Boolean,
			default: false,
		},
		hasSelectAll: {
			type: Boolean,
			default: false,
		},
		agentLevel: {
			type: Object,
			default: () => {
				return {
					index: 0,
					name: "零售客户",
				};
			},
		},
		order: {
			type: Object,
			default: () => {
				return {
					_id: "",
					name: "",
				};
			},
		},
		tips: {
			type: String,
			default: "",
		},
		filter: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	created() {
    this.getPriceRate();
  },
	mounted() {
    this.$store.commit('saveCurrDbSource',this.agentLevel)
  },
	methods: {
    getPriceRate(){
      this.$axios
          .post(`/curd/getPriceRate`)
          .then(json => {
            this.priceRate = json.data
            console.log('priceRate', this.priceRate[5])

          })
          .catch(json => {
          });
    },
    bianmaClick(){
      // this.$emit('bianMaInput',this.bianMa)
      if(this.bianMa.length != 26){
        return;
      }
      this.$axios
          .post(`/curd/lists/Product_color`,{
            skuid:this.bianMa,

          })
          .then(json => {
            this.handleInsert(json.data.datas,1)
            this.bianMa=''
          })
          .catch(json => {
            if(json.rstno == -400){
              this.$message.error(json.data.msg);
            }

            // this.$message.error("一次最多选择200条，请增加品类、品牌筛选！");
          });
    },
		onGetData(dataCounts){
			this.dataCounts = dataCounts;
		},
		handleChooseAllFilter() {
			if (this.dataCounts > 200) {
				this.$message.error("一次最多选择200条，请增加品类、品牌筛选！");
				return;
			}
			this.loadings.items = true;
			this.$axios
				.post(`/inventory/list_items_all/`,{
					query:this.filterTableSearch,
					kvFilter:this.itemFilters,
				})
				.then(json => {
					console.log(json.data.product_colors);
					for (const index in json.data.product_colors) {
						const product_color = json.data.product_colors[index];

						console.log(product_color);
						this.stocks = [];
						for (const i in product_color.items) {
							const item = product_color.items[i];
							if (item.amount <= 0) {
								continue;
							}
							this.stocks.push({
								amount: item.amount,
								_id: item._id,
								info: item,
							})
						}
						this._doInsert(product_color);
					}
					this.loadings.items = false;

				})
				.catch(json => {
					this.loadings.items = false;
				});
		},
		handleChooseAll(product_color) {
			this.stocks = [];
			this.loadings.items = true;


			this.$axios
				.post(`/inventory/list_items/${product_color._id}`)
				.then(json => {
					for (let k in json.data.datas) {
						if (json.data.datas[k].amount <= 0) {
							continue;
						}
						this.stocks.push({
							amount: json.data.datas[k].amount,
							_id: json.data.datas[k]._id,
							info: json.data.datas[k],
						})
					}

					this._doInsert(product_color);
					this.loadings.items = false;

				})
				.catch(json => {

				});
		},
		_doInsert(product_color, type=0) {
      const types = type || 0;
			let items = [];
			for (let i = 0; i < this.stocks.length; i++) {
				let item = {
					_id: this.stocks[i]._id,
					brand: product_color.brand,
					brand_show_id: product_color.brand_show_id,
					classify: product_color.classify,
					product_color: product_color,
					item: {
						_id: this.stocks[i]._id,
					},
					color: this.stocks[i].info.color,
					model: this.stocks[i].info.model,
					amount: this.stocks[i].amount,
					price_per: 0,
					warehouse:this.warehouse._id
				};
				if (this.isNeedCost) {
          if(types == 1){
            if (this.agentLevel.index == 1) {
              // item.price_per = this.stocks[i].info.price_1 * this.priceRate[1];
              item.price_per = this.stocks[i].info.price_1;
            }else if(this.agentLevel.index == 5){
              // item.price_per = this.stocks[i].info.price_1 * this.priceRate[5];
              item.price_per = this.stocks[i].info.price_1;
            }else {
              item.price_per = product_color.price_per;
            }
          }else {
            item.price_per = this.referencePrice;
          }
				} else {
					//没有价格输入框的情况下
					if (this.isUsePrice) {
						// if (this.stocks[i].info.is_special) {
						// 	item.price_per = this.stocks[i].info.price_special;
						// 	if (item.price_per == 0) {
						// 		item.price_per = product_color.price_special;
						// 	}
						// } else

						if (this.agentLevel.index == 0) {
							item.price_per = this.stocks[i].info.price_1;
							if (item.price_per == 0) {
								item.price_per = product_color.price_1;
							}
						} else if (this.agentLevel.index == 1) {
							// item.price_per = this.stocks[i].info.price_1 * this.priceRate[1];
							item.price_per = this.stocks[i].info.price_1;
							if (item.price_per == 0) {
								item.price_per = product_color.price_2;
							}
						} else if (this.agentLevel.index == 2) {
							item.price_per = this.stocks[i].info.price_3;
							if (item.price_per == 0) {
								item.price_per = product_color.price_3;
							}
						} else if (this.agentLevel.index == 3) {
							item.price_per = this.stocks[i].info.price_4;
							if (item.price_per == 0) {
								item.price_per = product_color.price_4;
							}
						} else if (this.agentLevel.index == 4) {
              item.price_per = this.stocks[i].info.price_5;
              if (item.price_per == 0) {
                item.price_per = product_color.price_5;
              }
            } else if (this.agentLevel.index == 5) {
							// item.price_per = this.stocks[i].info.price_1 * this.priceRate[5];
							item.price_per = this.stocks[i].info.price_1;
							if (item.price_per == 0) {
								item.price_per = product_color.price_1 * 0.5;
							}
						} else {
							item.price_per = this.stocks[i].info.price_1;
							if (item.price_per == 0) {
								item.price_per = product_color.price_1;
							}
						}
					} else {
						//成本
						item.price_per = this.stocks[i].info.cost_per;
					}
				}

        item.price_per = this.formItem.price_per;
        if(item.price_per === 0){
          item.price_per = this.referencePrice
        }
				item.total_price = (item.price_per * this.stocks[i].amount).toFixed(2);

        console.log(666666,this.formItem.price_per);
        console.log(7777777,this.referencePrice);
        console.log(88888888,item.price_per);
				items.push(item);

			}
			this.$emit("insert", items);
			this.handleResetProduct();
		},
	},
	watch: {
    agentLevel(){
      // console.log('变动',this.agentLevel)
      this.$store.commit('saveCurrDbSource',this.agentLevel)
    },
		product_color(val) {
			this.recordId = val._id;

			if (this.isUsePrice) {
				// if (this.product_color.is_special) {
				// 	this.formItem.price_per = 0 + this.product_color.price_special;
				// } else
        console.log('this.agentLevel.index',this.agentLevel.index)


				if (this.agentLevel.index == 0) {
					this.formItem.price_per = 0 + this.product_color.price_1;
				} else if (this.agentLevel.index == 1) {
					// this.formItem.price_per = 0 + this.product_color.price_1 * this.priceRate[1];
					this.formItem.price_per = 0 + this.product_color.price_1;
				} else if (this.agentLevel.index == 2) {
					this.formItem.price_per = 0 + this.product_color.price_3;
				} else if (this.agentLevel.index == 3) {
					this.formItem.price_per = 0 + this.product_color.price_4;
				} else if (this.agentLevel.index == 4) {
					this.formItem.price_per = 0 + this.product_color.price_5;
				} else if (this.agentLevel.index == 5) {
          // this.formItem.price_per = 0 + this.product_color.price_1 * this.priceRate[5];
          this.formItem.price_per = 0 + this.product_color.price_1;
        } else {
					this.formItem.price_per = 0 + this.product_color.price_1;
				}
			} else {
				this.formItem.price_per = 0 + this.product_color.cost_per;
			}

      console.log('this.formItem.price_per.referencePrice',this.referencePrice)
		},
		warehouse(val){
			this.warehouseIdNew = this.warehouse._id
		}
	},
};
</script>
<style lang="scss" scoped>
</style>
